import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, Link } from '@mui/material';

export const BookingContainer = styled(Box)(({ theme }: any) => ({
  width: '100%',
  minHeight: '100vh',
  background: theme.palette.background.default,
  padding: 0,
}));

export const AdventuresSection = styled('section')(({ theme }) => ({
  background: theme.palette.blue.background,
  padding: '40px 0 80px 0',
  [theme.breakpoints.down('sm')]: {
    padding: '10px 0 40px 0',
  },
}));

export const ExperiencesSection = styled('section')(({ theme }) => ({
  background: theme.palette.blue.main,
  padding: '20px 0 80px 0',
  color: '#fff',
}));

export const CategoryHeader = styled('div')(({ theme }) => ({
  fontSize: 32,
  fontWeight: 800,
  marginBottom: theme.spacing(2),
  color: theme.palette.blue.main,
  letterSpacing: 0.2,
  [theme.breakpoints.down('sm')]: {
    fontSize: 24,
  },
}));

export const TourGrid = styled('div')<{
  $columns?: number;
}>(({ theme, $columns = 3 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${$columns}, 1fr)`,
  gap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: `repeat(${$columns - 1}, 1fr)`,
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const TourCard = styled(Link)(({ theme }) => ({
  background: theme.palette.blue.background,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 300,
  maxHeight: 'auto',
  position: 'relative',
  textDecoration: 'none',
  color: 'inherit',
}));

export const TourImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 320,
  objectFit: 'cover',
  display: 'block',
  borderRadius: 10,
  [theme.breakpoints.down('md')]: {
    height: 240,
  },

  [theme.breakpoints.down('sm')]: {
    height: 180,
  },
}));

export const TourContent = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  paddingBlock: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'start',
    paddingBlock: theme.spacing(1),
  },
}));

export const ContentTourText = styled(Box)(({ theme }) => ({
  color: theme.palette.black.main,
  fontWeight: 500,
  fontSize: 16,
  margin: '8px 0 4px 0',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 5,
  WebkitBoxOrient: 'vertical',
  [theme.breakpoints.down('sm')]: {
    WebkitLineClamp: 5,
  },
}));

export const PriceText = styled('div')(({ theme }) => ({
  color: theme.palette.hightlight[10],
  fontWeight: 500,
  fontSize: 19,
  margin: '8px 0 0px 0',
}));

export const BookButton = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: theme.spacing(1.5, 0),
  fontWeight: 500,
  fontSize: 19,
  width: '156px',
  marginTop: theme.spacing(2),
  cursor: 'pointer',
  transition: 'background 0.2s',
  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.75),
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const Badge = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: 16,
  left: 16,
  background: '#F05A28',
  color: '#fff',
  borderRadius: 6,
  padding: '2px 10px',
  fontWeight: 700,
  fontSize: 13,
  zIndex: 2,
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
}));

export const HorizontalScrollGrid = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3),
  overflowX: 'auto',
  scrollBehavior: 'smooth',
  paddingBottom: theme.spacing(1),
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
}));
